var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Users',{attrs:{"list-users":_vm.listUsers,"deactivate-user":_vm.deactivateUser,"invite-path":"/shipper/users/invite"}})}
var staticRenderFns = []

export { render, staticRenderFns }